import { defineMessages, useIntl } from 'react-intl';
import { Accordion } from '@cbhq/cds-web/accordion/Accordion';
import { AccordionItem } from '@cbhq/cds-web/accordion/AccordionItem';
import { VStack } from '@cbhq/cds-web/layout';
import { Link, TextBody } from '@cbhq/cds-web/typography';

const DOWNLOAD_WALLET_URL = 'https://www.coinbase.com/en-ca/wallet/downloads';
const MIGRATING_INSTRUCTIONS_URL =
  'https://help.coinbase.com/en/migrating-to-the-onchain-payment-protocol';
const VIEW_FUNDS_INSTRUCTIONS_URL =
  'https://help.coinbase.com/en/contact-us/support-faq/coinbase-wallet/how-to-confirm-transfer-of-crypto-funds-from-coinbase-wallet';

export const messages = defineMessages({
  faq1Question: {
    id: 'fundSettlementFaq1Question',
    defaultMessage: 'Some of my assets are missing. Where are they?',
    description: 'Question for FAQ item 1 for fund settlement',
  },
  faq1Answer: {
    id: 'fundSettlementFaq1Answer',
    defaultMessage:
      "If some of your assets aren't shown here, please {downloadCoinbaseWallet} or another self-custody wallet. Open the app, then select the option to import an existing wallet. Enter your recovery phrase, and your missing assets should be accessible. For further assistance, please read the {detailedInstructions} in our Help Center.",
    description: 'Answer for FAQ item 1 for fund settlement',
  },
  faq2Question: {
    id: 'fundSettlementFaq2Question',
    defaultMessage: "I'm ready to withdraw my funds. Where will they be withdrawn to?",
    description: 'Question for FAQ item 2 for fund settlement',
  },
  faq2Answer: {
    id: 'fundSettlementFaq2Answer',
    defaultMessage:
      "We'll ask you to enter a wallet address for each asset. The asset will then be sent to that wallet. To get an address, you can use Coinbase, Coinbase Wallet, or any other self-custody wallet or crypto exchange that supports Bitcoin, Bitcoin Cash, Dogecoin, Litecoin, and Ethereum.",
    description: 'Answer for FAQ item 2 for fund settlement',
  },
  faq3Question: {
    id: 'fundSettlementFaq3Question',
    defaultMessage: 'How do I view my balances after withdrawing my funds?',
    description: 'Question for FAQ item 3 for fund settlement',
  },
  faq3Answer: {
    id: 'fundSettlementFaq3Answer',
    defaultMessage:
      'Your balances will be available immediately after the transfer is complete. Simply open the wallet you used for the transfer, and your updated balances should be visible there. Visit our Help Center to learn how to {viewYourFunds} in Coinbase Wallet after you withdraw them.',
    description: 'Answer for FAQ item 3 for fund settlement',
  },
  downloadCoinbaseWallet: {
    id: 'downloadCoinbaseWallet',
    defaultMessage: 'download Coinbase Wallet',
    description: 'Label for the download Coinbase Wallet link',
  },
  detailedInstructions: {
    id: 'detailedInstructions',
    defaultMessage: 'detailed instructions',
    description: 'Label for the detailed instructions link',
  },
  viewYourFunds: {
    id: 'viewYourFunds',
    defaultMessage: 'view your funds',
    description: 'Label for the view your funds link',
  },
});

export function FundSettlementFAQ() {
  const { formatMessage } = useIntl();
  return (
    <VStack>
      <Accordion>
        <AccordionItem
          itemKey={messages.faq1Question.id}
          title={formatMessage(messages.faq1Question)}
        >
          <TextBody as="p">
            {formatMessage(messages.faq1Answer, {
              downloadCoinbaseWallet: (
                <Link href={DOWNLOAD_WALLET_URL} openInNewWindow>
                  {formatMessage(messages.downloadCoinbaseWallet)}
                </Link>
              ),
              detailedInstructions: (
                <Link href={MIGRATING_INSTRUCTIONS_URL} openInNewWindow>
                  {formatMessage(messages.detailedInstructions)}
                </Link>
              ),
            })}
          </TextBody>
        </AccordionItem>
      </Accordion>
      <Accordion>
        <AccordionItem
          itemKey={messages.faq2Question.id}
          title={formatMessage(messages.faq2Question)}
        >
          <TextBody as="p">{formatMessage(messages.faq2Answer)}</TextBody>
        </AccordionItem>
      </Accordion>
      <Accordion>
        <AccordionItem
          itemKey={messages.faq3Question.id}
          title={formatMessage(messages.faq3Question)}
        >
          <TextBody as="p">
            {formatMessage(messages.faq3Answer, {
              viewYourFunds: (
                <Link href={VIEW_FUNDS_INSTRUCTIONS_URL} openInNewWindow>
                  {formatMessage(messages.viewYourFunds)}
                </Link>
              ),
            })}
          </TextBody>
        </AccordionItem>
      </Accordion>
    </VStack>
  );
}
